/** @format */

import React from 'react'

class Refundpolicy extends React.Component {
	render() {
		return (
			<>
				<h1>return policy</h1>
				<nav
					className='navbar navbar-expand-lg bg-dark navbar-light d-none d-lg-block '
					id='templatemo_nav_top'>
					<div className='container text-light'>
						<div className='w-100 d-flex justify-content-between'>
							<div>
								<i className='fa fa-envelope mx-2'></i>
								<a
									className='navbar-sm-brand text-light text-decoration-none'
									href='mailto:SabZ@gmail.com'>
									SabZ@gmail.com
								</a>
								<i className='fa fa-phone mx-2'></i>
								<a
									className='navbar-sm-brand text-light text-decoration-none'
									href='tel:+91 7382200558 '>
									+91 7382200558
								</a>
							</div>
							<div>
								<a
									className='text-light'
									href='https://fb.com/templatemo'
									rel='noopener noreferrer'
									target='_blank'
									>
									<i className='fab fa-facebook-f fa-sm fa-fw me-2'></i>
								</a>
								<a
									className='text-light'
									href='https://www.instagram.com/'
									rel='noopener noreferrer'
									target='_blank'>
									<i className='fab fa-instagram fa-sm fa-fw me-2'></i>
								</a>
								<a
									className='text-light'
									href='https://twitter.com/'
									rel='noopener noreferrer'
									target='_blank'>
									<i className='fab fa-twitter fa-sm fa-fw me-2'></i>
								</a>
								<a
									className='text-light'
									href='https://www.linkedin.com/'
									rel='noopener noreferrer'
									target='_blank'>
									<i className='fab fa-linkedin fa-sm fa-fw'></i>
								</a>
							</div>
						</div>
					</div>
				</nav>

				{/* <!-- Close Top Nav -->

    <style>
        .text-align{
            text-align:justify;
        }
    </style> */}

				<div className='container'>
					<div className='row'>
						<div className='col-lg-12 mb-0 d-flex align-items-center'>
							<div className='text-align align-self-center'>
								<h3 className='h2 text-success text-align'>
									{' '}
									<b>Refund policy:</b>{' '}
								</h3>
								<p>
									<li>
										Sabz Agri Service Private Limited will allow returns only at
										the time of delivery (if customer is not satisfied with
										quality and quantity that has been delivered). And for this
										quantity (item/items that has/have been returned) we will
										refund the money that you have paid directly for that
										item/items.
									</li>
									<br />
									<li>
										Kindly choose the return option in the app and select the
										items that you’re willing to return, after which the amount
										will be refunded to your parent account or through an
										account which you have paid or cash within 30 days.
									</li>{' '}
									<br />
									<li>
										Late or missing refunds (if applicable) If you haven’t
										received a refund yet, first check your bank account again.
										Then contact your credit card company, it may take some time
										before your refund is officially posted.
									</li>
									<br />
									<li>
										Next contact your bank. There is often some processing time
										before a refund is posted. If you’ve done all of this and
										you still have not received your refund yet, please contact
										us at <b>director@sabzonline.in </b> Sale items (if applicable)
									</li>
									<br />
									<li>
										Only regular priced items may be refunded, unfortunately
										sale items cannot be refunded.
									</li>
								</p>
							</div>
						</div>
					</div>
				</div>

				
			</>
		)
	}
}
export default Refundpolicy
